import { FinanciamentoProposta, TNacionalidade } from "src/types";
import { IAvalistaRequestDom, ICategoriaOcupacao, IOcupacaoEmpresaRequestDom, IOcupacaoRequestDom, IPessoaFisicaConjugeRequestDom, IPropostaDadosRequestDom, IPropostaEnderecoRequestDom, TCaregoriaOcupacao, TContaBancaria, TEstadoCivil, TGenero, TPartilhaBens, TSituacaoEndereco } from "./types";

export const SITUACAO_FINANCIAMENTO_PENDENTE = 'pendente';
export const SITUACAO_FINANCIAMENTO_FATURAMENTO = 'faturamento';
export const SITUACAO_FINANCIAMENTO_PAGO = 'pago';
export const SITUACAO_FINANCIAMENTO_CANCELADO = 'cancelado';
export const SITUACAO_FINANCIAMENTO_RECUSADO = 'recusado';

export const SITUACAO_PROPOSTA_PENDENTE = 'pendente';
export const SITUACAO_PROPOSTA_PREENCHIDO = 'preenchido';
export const SITUACAO_PROPOSTA_ENVIADO = 'enviado';
export const SITUACAO_PROPOSTA_REVISAO = 'revisao';
export const SITUACAO_PROPOSTA_APROVADO = 'aprovado';
export const SITUACAO_PROPOSTA_ERRO = 'erro';

export const SITUACAO_PROPOSTA_DOCUMENTOS_PENDENTE = 'pendente';
export const SITUACAO_PROPOSTA_DOCUMENTOS_PREENCHIDO = 'preenchido';
export const SITUACAO_PROPOSTA_DOCUMENTOS_ENVIADO = 'enviado';
export const SITUACAO_PROPOSTA_DOCUMENTOS_REVISAO = 'revisao';
export const SITUACAO_PROPOSTA_DOCUMENTOS_APROVADO = 'aprovado';
export const SITUACAO_PROPOSTA_DOCUMENTOS_ERRO = 'erro';

export const AVISO_ENTRADA_FINANCIAMENTO = "* O valor de entrada indicado na simulação deverá ser repassado a financeira como entrada do financiamento.";
export const AVISO_ENTRADA_FINANCIAMENTO_FORMALIZACAO = "* O valor de entrada indicado na lista de planos deverá ser repassado a financeira como entrada do financiamento.";

export const FINANCEIRA_BV_ID = 1
export const FINANCEIRA_SANTANDER_ID = 2
export const FINANCEIRA_PARCEIRO_ID = 3

export const DADOS_FIADORES_DEFAULT = {
    conjuge: {
        data_expedicao_rg: null,
        data_nascimento: null,
        documento: null,
        email: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_nome: null,
            complemento: null,
            logradouro: null,
            numero: null,
            uf: null,
        },
        estado_civil: null,
        genero: null,
        nacionalidade: null,
        naturalidade: null,
        naturalidade_cidade: null,
        naturalidade_uf: null,
        nome: null,
        nome_mae: null,
        ocupacao: {
            descricao_profissao: null,
            natureza: null,
            profissao: null,
            telefone_comercial: null,
            tempo_operacao: null,
        },
        orgao_expedidor_rg: null,
        regime_bens: null,
        renda_mensal: null,
        rg: null,
        telefone: null,
        uf_expedidor_rg: null,
        valor_patrimonio: null,
    },
    data_expedicao_rg: null,
    data_nascimento: null,
    documento: null,
    email: null,
    endereco: {
        bairro: null,
        cep: null,
        cidade: null,
        cidade_nome: null,
        complemento: null,
        logradouro: null,
        numero: null,
        uf: null,
    },
    estado_civil: null,
    genero: null,
    nacionalidade: null,
    naturalidade: null,
    naturalidade_cidade: null,
    naturalidade_uf: null,
    nome: null,
    nome_mae: null,
    ocupacao: {
        descricao_profissao: null,
        natureza: null,
        profissao: null,
        telefone_comercial: null,
        tempo_operacao: null,
    },
    orgao_expedidor_rg: null,
    regime_bens: null,
    renda_mensal: null,
    rg: null,
    telefone: null,
    uf_expedidor_rg: null,
    valor_patrimonio: null,

}

export const DADOS_DEFAULT: FinanciamentoProposta = {
    dados_bancarios: {
        banco_id: null,
        autorizar_debito_conta: false,
        agencia: null,
        digito_agencia: null,
        conta: null,
        digito_conta: null
    },
    dados_pessoa_fisica: {
        data_expedicao_rg: null,
        data_nascimento: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_nome: null,
            complemento: null,
            logradouro: null,
            numero: null,
            uf: null
        },
        endereco_residencial: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_nome: null,
            complemento: null,
            logradouro: null,
            numero: null,
            uf: null,
            situacao_imovel: null
        },
        estado_civil: null,
        genero: null,
        nacionalidade: null,
        naturalidade: null,
        naturalidade_cidade: null,
        naturalidade_uf: null,
        nome_mae: null,
        ocupacao: {
            descricao_profissao: null,
            natureza: null,
            categoria: null,
            profissao: null,
            telefone_comercial: null,
            tempo_operacao: null,
        },
        orgao_expedidor_rg: null,
        regime_bens: null,
        renda_mensal: null,
        rg: null,
        uf_expedidor_rg: null,
        valor_patrimonio: null,
        referencias: [
            {
                nome: null,
                telefone: null,
            },
            {
                nome: null,
                telefone: null,
            }
        ]
    },
    dados_conjuge: {
        data_expedicao_rg: null,
        data_nascimento: null,
        documento: null,
        email: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_nome: null,
            complemento: null,
            logradouro: null,
            numero: null,
            uf: null,
        },
        estado_civil: null,
        genero: null,
        nacionalidade: null,
        naturalidade: null,
        naturalidade_cidade: null,
        naturalidade_uf: null,
        nome: null,
        nome_mae: null,
        ocupacao: {
            descricao_profissao: null,
            natureza: null,
            profissao: null,
            telefone_comercial: null,
            tempo_operacao: null
        },
        orgao_expedidor_rg: null,
        regime_bens: null,
        renda_mensal: null,
        rg: null,
        telefone: null,
        uf_expedidor_rg: null,
        valor_patrimonio: null,
    },
    dados_fiadores: [],
    situacao: SITUACAO_FINANCIAMENTO_PENDENTE,
    situacao_proposta: SITUACAO_PROPOSTA_PENDENTE,
    situacao_documentos: SITUACAO_PROPOSTA_DOCUMENTOS_PENDENTE

}



export const MASCULINO_ID = 0;
export const FEMININO_ID = 1;
export const GENERO = [
    {
        id: MASCULINO_ID,
        nome: "Masculino"
    },
    {
        id: FEMININO_ID,
        nome: "Feminino"
    },
];

export const SOLTEIRO_ID = 0
export const CASADO_ID = 1
export const DIVORCIADO_ID = 2
export const VIUVO_ID = 3
export const ESTADO_CIVIL = [
    {
        id: SOLTEIRO_ID,
        nome: "Solteiro"
    },
    {
        id: CASADO_ID,
        nome: "Casado"
    },
    {
        id: DIVORCIADO_ID,
        nome: "Divorciado"
    },
    {
        id: VIUVO_ID,
        nome: "Viúvo"
    }
];

export const ASSALARIADO_ID = 0;
export const EMPRESARIO_ID = 1;
export const AUTONOMO_ID = 2;
export const SERVIDOR_PUBLICO_ID = 3;
export const APOSENTADO_ID = 4;

export const NATUREZA_OCUPACAO = [
    {
        id: ASSALARIADO_ID,
        nome: "Assalariado",
    },
    {
        id: EMPRESARIO_ID,
        nome: "Empresário",
    },
    {
        id: AUTONOMO_ID,
        nome: "Autônomo",
    },
    {
        id: SERVIDOR_PUBLICO_ID,
        nome: "Servidor público",
    },
    {
        id: APOSENTADO_ID,
        nome: "Aposentado",
    },
]

export const CATEGORIA: ICategoriaOcupacao[] = [
    {
        id: "aposentadoOuPensionista",
        nome: "Aposentado/Pensionista",
    },
    {
        id: "assalariado",
        nome: "Assalariado",
    },
    // {
    //     id: "autonomo",
    //     nome: "Autônomo",
    // },
    {
        id: "empresario",
        nome: "Empresário",
    },
    // {
    //     id: "liberal",
    //     nome: "Profissional liberal"
    // },
    {
        id: "publico",
        nome: "Servidor público",
    },
]

export const ALUGADO_ID = 0;
export const PROPRIO_QUITADO_ID = 1;
export const PROPRIO_FINANCIADO_ID = 2;
export const FAMILIAR_ID = 3;
export const CEDIDO_ID = 4;

export const PROPRIEDADE_RESIDENCIA = [
    {
        id: ALUGADO_ID,
        nome: "Alugado",
    },
    {
        id: PROPRIO_QUITADO_ID,
        nome: "Próprio quitado",
    },
    {
        id: PROPRIO_FINANCIADO_ID,
        nome: "Próprio financiado",
    },
    {
        id: FAMILIAR_ID,
        nome: "Familiar",
    },
    {
        id: CEDIDO_ID,
        nome: "Cedido",
    },
]

export const COMUNHAO_UNIVERSAL_BENS = 0;
export const COMUNHAO_PARCIAL_BENS = 1;
export const PARTICIPACAO_FINAL_AQUESTOS = 2;
export const SEPARACAO_CONVENCIONAL_BENS = 3;
export const SEPARACAO_OBRIGATORIA_BENS = 4;

export const REGIME_BENS = [
    {
        id: COMUNHAO_UNIVERSAL_BENS,
        nome: "Comunhão universal de bens",
    },
    {
        id: COMUNHAO_PARCIAL_BENS,
        nome: "Comunhão parcial de bens",
    },
    {
        id: PARTICIPACAO_FINAL_AQUESTOS,
        nome: "Participação final de aquestos",
    },
    {
        id: SEPARACAO_CONVENCIONAL_BENS,
        nome: "Separação convencional de bens",
    },
    {
        id: SEPARACAO_OBRIGATORIA_BENS,
        nome: "Separação obrigatória de bens",
    },
]

export const BRASILEIRO = "brasileiro";
export const ESTRANGEIRO = "estrangeiro";
export const NATURALIZADO = "naturalizado";

export const NACIONALIDADE = [
    {
        text: "Brasileiro(a)",
        value: BRASILEIRO,
    },
    // {
    //     text: "Estrangiero(a)",
    //     value: ESTRANGEIRO,
    // },
    {
        text: "Naturalizado(a)",
        value: NATURALIZADO,
    },
];

export const ESTADO_CIVIL_SOLTEIRO_ID: TEstadoCivil = "solteiro"
export const ESTADO_CIVIL_CASADO_ID: TEstadoCivil = "casado"
export const ESTADO_CIVIL_DIVORCIADO_ID: TEstadoCivil = "divorciado"
export const ESTADO_CIVIL_VIUVO_ID: TEstadoCivil = "viuvo"
export const ESTADOS_CIVIS = [
    {
        id: ESTADO_CIVIL_SOLTEIRO_ID,
        nome: "Solteiro"
    },
    {
        id: ESTADO_CIVIL_CASADO_ID,
        nome: "Casado"
    },
    {
        id: ESTADO_CIVIL_DIVORCIADO_ID,
        nome: "Divorciado"
    },
    {
        id: ESTADO_CIVIL_VIUVO_ID,
        nome: "Viúvo"
    }
];

export const SITUACAO_IMOVEL_ALUGADO_ID: TSituacaoEndereco = "alugado";
export const SITUACAO_IMOVEL_PROPRIO_QUITADO_ID: TSituacaoEndereco = "proprio";
export const SITUACAO_IMOVEL_PROPRIO_FINANCIADO_ID: TSituacaoEndereco = "financiado";
export const SITUACAO_IMOVEL_FAMILIAR_ID: TSituacaoEndereco = "familiar";
export const SITUACAO_IMOVEL_CEDIDO_ID: TSituacaoEndereco = "cedido";

export const SITUACOES_RESIDENCIA = [
    {
        id: SITUACAO_IMOVEL_ALUGADO_ID,
        nome: "Alugado",
    },
    {
        id: SITUACAO_IMOVEL_PROPRIO_QUITADO_ID,
        nome: "Próprio quitado",
    },
    {
        id: SITUACAO_IMOVEL_PROPRIO_FINANCIADO_ID,
        nome: "Próprio financiado",
    },
    {
        id: SITUACAO_IMOVEL_FAMILIAR_ID,
        nome: "Familiar",
    },
    {
        id: SITUACAO_IMOVEL_CEDIDO_ID,
        nome: "Cedido",
    },
]

export const PARTILHA_COMUNHAO_UNIVERSAL_BENS: TPartilhaBens = "comunhaoUniversalBens";
export const PARTILHA_COMUNHAO_PARCIAL_BENS: TPartilhaBens = "comunhaoParcialBens";
export const PARTILHA_PARTICIPACAO_FINAL_AQUESTOS: TPartilhaBens = "participacaoFinalAquestos";
export const PARTILHA_SEPARACAO_CONVENCIONAL_BENS: TPartilhaBens = "separacaoConvencionalBens";
export const PARTILHA_SEPARACAO_OBRIGATORIA_BENS: TPartilhaBens = "separacaoObrigatoriaBens";

export const PARTILHA_BENS = [
    {
        id: PARTILHA_COMUNHAO_UNIVERSAL_BENS,
        nome: "Comunhão universal de bens",
    },
    {
        id: PARTILHA_COMUNHAO_PARCIAL_BENS,
        nome: "Comunhão parcial de bens",
    },
    {
        id: PARTILHA_PARTICIPACAO_FINAL_AQUESTOS,
        nome: "Participação final de aquestos",
    },
    {
        id: PARTILHA_SEPARACAO_CONVENCIONAL_BENS,
        nome: "Separação convencional de bens",
    },
    {
        id: PARTILHA_SEPARACAO_OBRIGATORIA_BENS,
        nome: "Separação obrigatória de bens",
    },
]

export const GENERO_MASCULINO_ID: TGenero = 'masculino';
export const GENERO_FEMININO_ID: TGenero = "feminino";
export const GENERO_LIST = [
    {
        id: GENERO_MASCULINO_ID,
        nome: "Masculino"
    },
    {
        id: GENERO_FEMININO_ID,
        nome: "Feminino"
    },
];

export const TIPO_CONTA_CORRENTE: TContaBancaria = "corrente"
export const TIPO_CONTA_POUPANCA: TContaBancaria = "poupanca"
export const TIPO_CONTA = [
    {
        id: TIPO_CONTA_CORRENTE,
        nome: "Corrente"
    },
    {
        id: TIPO_CONTA_POUPANCA,
        nome: "Poupança"
    },
];
export const DEFAULT_DATA_ENDERECO: IPropostaEnderecoRequestDom = {
    bairro: null,
    cep: null,
    cidade: null,
    cidade_ibge: null,
    complemento: null,
    data_inicio_endereco: null,
    estado: null,
    logradouro: null,
    numero: null,
    situacao: null,
}



export const DEFAULT_DATA_EMPRESA: IOcupacaoEmpresaRequestDom = {
    capital_social: null,
    cnpj: null,
    data_fundacao: null,
    endereco: {
        bairro: null,
        cep: null,
        cidade: null,
        cidade_ibge: null,
        complemento: null,
        estado: null,
        logradouro: null,
        numero: null,
    },
    fantasia: null,
    faturamento_mensal: null,
    nome: null,
    telefone: null,
}

export const DEFAULT_DATA_OCUPACAO: IOcupacaoRequestDom = {
    categoria: null,
    data_inicio_ocupacao: null,
    empresa: {
        capital_social: null,
        cnpj: null,
        data_fundacao: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_ibge: null,
            complemento: null,
            estado: null,
            logradouro: null,
            numero: null,
        },
        fantasia: null,
        faturamento_mensal: null,
        nome: null,
        telefone: null,
    },
    numeroBeneficio: null,
    profissao: null,
    renda_mensal: null,
    telefone: null,
}

export const DEFAULT_DATA_CONJUGE: IPessoaFisicaConjugeRequestDom = {
    data_nascimento: null,
    documento: null,
    documento_rg_rne: null,
    email: null,
    endereco: {
        bairro: null,
        cep: null,
        cidade: null,
        cidade_ibge: null,
        complemento: null,
        data_inicio_endereco: null,
        estado: null,
        logradouro: null,
        numero: null,
        situacao: null,
    },
    genero: null,
    nacionalidade: null,
    nacionalidade_pais: null,
    nome: null,
    nome_mae: null,
    ocupacao: {
        categoria: null,
        data_inicio_ocupacao: null,
        empresa: {
            capital_social: null,
            cnpj: null,
            data_fundacao: null,
            endereco: {
                bairro: null,
                cep: null,
                cidade: null,
                cidade_ibge: null,
                complemento: null,
                estado: null,
                logradouro: null,
                numero: null,
            },
            fantasia: null,
            faturamento_mensal: null,
            nome: null,
            telefone: null,
        },
        numeroBeneficio: null,
        profissao: null,
        renda_mensal: null,
        telefone: null,
    },
    patrimonio: null,
    telefone: null,
}

export const DEFAULT_DATA_AVALISTA: IAvalistaRequestDom = {
    conjuge: {
        data_nascimento: null,
        documento: null,
        documento_rg_rne: null,
        email: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_ibge: null,
            complemento: null,
            data_inicio_endereco: null,
            estado: null,
            logradouro: null,
            numero: null,
            situacao: null,
        },
        genero: null,
        nacionalidade: null,
        nacionalidade_pais: null,
        nome: null,
        nome_mae: null,
        ocupacao: {
            categoria: null,
            data_inicio_ocupacao: null,
            empresa: {
                capital_social: null,
                cnpj: null,
                data_fundacao: null,
                endereco: {
                    bairro: null,
                    cep: null,
                    cidade: null,
                    cidade_ibge: null,
                    complemento: null,
                    estado: null,
                    logradouro: null,
                    numero: null,
                },
                fantasia: null,
                faturamento_mensal: null,
                nome: null,
                telefone: null,
            },
            numeroBeneficio: null,
            profissao: null,
            renda_mensal: null,
            telefone: null,
        },
        patrimonio: null,
        telefone: null,
    },
    data_nascimento: null,
    documento: null,
    documento_rg_rne: null,
    email: null,
    endereco: {
        bairro: null,
        cep: null,
        cidade: null,
        cidade_ibge: null,
        complemento: null,
        data_inicio_endereco: null,
        estado: null,
        logradouro: null,
        numero: null,
        situacao: null,
    },
    estado_civil: null,
    genero: null,
    nacionalidade: null,
    nacionalidade_pais: null,
    nome: null,
    nome_mae: null,
    ocupacao: {
        categoria: null,
        data_inicio_ocupacao: null,
        empresa: {
            capital_social: null,
            cnpj: null,
            data_fundacao: null,
            endereco: {
                bairro: null,
                cep: null,
                cidade: null,
                cidade_ibge: null,
                complemento: null,
                estado: null,
                logradouro: null,
                numero: null,
            },
            fantasia: null,
            faturamento_mensal: null,
            nome: null,
            telefone: null,
        },
        numeroBeneficio: null,
        profissao: null,
        renda_mensal: null,
        telefone: null,
    },
    partilha_bens: null,
    patrimonio: null,
    telefone: null,
    tipo: null,
}



export const DEFAULT_DATA_FINANCIAMENTO: IPropostaDadosRequestDom = {
    avalistas: [],
    dados_bancarios: {
        agencia: null,
        agencia_digito: null,
        banco: null,
        conta: null,
        conta_digito: null,
        debito_em_conta: null,
        tipo: null
    },
    pessoa_fisica: {
        conjuge: {
            data_nascimento: null,
            documento: null,
            documento_rg_rne: null,
            email: null,
            endereco: {
                bairro: null,
                cep: null,
                cidade: null,
                cidade_ibge: null,
                complemento: null,
                data_inicio_endereco: null,
                estado: null,
                logradouro: null,
                numero: null,
                situacao: null,
            },
            genero: null,
            nacionalidade: null,
            nacionalidade_pais: null,
            nome: null,
            nome_mae: null,
            ocupacao: {
                categoria: null,
                data_inicio_ocupacao: null,
                empresa: {
                    capital_social: null,
                    cnpj: null,
                    data_fundacao: null,
                    endereco: {
                        bairro: null,
                        cep: null,
                        cidade: null,
                        cidade_ibge: null,
                        complemento: null,
                        estado: null,
                        logradouro: null,
                        numero: null,
                    },
                    fantasia: null,
                    faturamento_mensal: null,
                    nome: null,
                    telefone: null,
                },
                numeroBeneficio: null,
                profissao: null,
                renda_mensal: null,
                telefone: null,
            },
            patrimonio: null,
            telefone: null,
        },
        data_nascimento: null,
        documento_rg_rne: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_ibge: null,
            complemento: null,
            data_inicio_endereco: null,
            estado: null,
            logradouro: null,
            numero: null,
            situacao: null,
        },
        estado_civil: null,
        genero: null,
        nacionalidade: null,
        nacionalidade_pais: null,
        nome_mae: null,
        ocupacao: {
            categoria: null,
            data_inicio_ocupacao: null,
            empresa: {
                capital_social: null,
                cnpj: null,
                data_fundacao: null,
                endereco: {
                    bairro: null,
                    cep: null,
                    cidade: null,
                    cidade_ibge: null,
                    complemento: null,
                    estado: null,
                    logradouro: null,
                    numero: null,
                },
                fantasia: null,
                faturamento_mensal: null,
                nome: null,
                telefone: null,
            },
            numeroBeneficio: null,
            profissao: null,
            renda_mensal: null,
            telefone: null,
        },
        partilha_bens: null,
        patrimonio: null,
    },
    pessoa_juridica: {
        atividade: null,
        capital_social: null,
        data_fundacao: null,
        endereco: {
            bairro: null,
            cep: null,
            cidade: null,
            cidade_ibge: null,
            complemento: null,
            estado: null,
            logradouro: null,
            numero: null,
        },
        fantasia: null,
        faturamento_mensal: null,
        grupo_atividades: null,
        natureza_legal: null,
        tipo_empresa: null,
    },
}
